import { useState } from 'react';
import { IonSearchbar, useIonRouter } from '@ionic/react';

// Search box in the channels sub-bar. It is an entry point, not an inline
// searcher: the user types and presses Enter, which navigates to the dedicated
// search screen carrying the typed term. The tab itself keeps showing the
// followed-channels timeline.
export const ChannelSearchBox = () => {
  const ionRouter = useIonRouter();
  const [value, setValue] = useState('');

  const goToSearch = () => {
    ionRouter.push(`/app/main/channels/buscar?q=${encodeURIComponent(value.trim())}`);
  };

  return (
    <IonSearchbar
      className="channel-search-box w-full"
      placeholder="Buscar canal"
      data-testid="channel-search-box"
      value={value}
      onIonInput={(e) => setValue(e.detail.value ?? '')}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          goToSearch();
        }
      }}
    />
  );
};
